import DefaultFlowProps from './parts/DefaultFlowProps';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;

export default class DefaultFlowPropertiesProvider {

  constructor(propertiesPanel, translate) {
    
    this.getGroups = function (element) {
      return function (groups) {
        // Add the new group
        if (is(element, 'bpmn:SequenceFlow')) {
          // Seulement s'il s'agit du type de flèche "par défaut"
          // Pour le savoir, on regarde la valeur "default" de l'élément source (d'où part la flèche)
          if (element.source && element.source.businessObject.default) {
            const defaultElement = element.source.businessObject.default;
            if (defaultElement.id === element.id) {
              groups.push(createDefaultFlowGroup(element, translate));
            }
          }
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

DefaultFlowPropertiesProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom group called "Condition".
function createDefaultFlowGroup(element, translate) {

  const defaultFlowGroup = {
    id: 'defaultFlow',
    label: translate('Trigger delay'),  
    entries: DefaultFlowProps(element),
    // tooltip: translate('Group tooltip')
  };

  return defaultFlowGroup;
}